/**
 * Created by piotr.pozniak@thebeaverhead.com on 14/10/2018.
 */

import React from "react";
import classNames from "classnames";

/**
 *
 * @param {string} className
 * @returns {Element}
 * @constructor
 */
const LoadingIndicator = (className) => {
  return (
    <div className={classNames("loader", className)}>
      <div className="progress">
        <div className="indeterminate"></div>
      </div>
    </div>
  );
};

export default LoadingIndicator;
